/* Keiki Co. — FAQ page enhancement.
 *
 * The page works with this file absent: every row is a real <details>, so it
 * opens and closes on click and on Enter/Space with no script at all. What this
 * adds is the slide (a <details> alone snaps), the expand-all control, and
 * smooth jumps from the topic nav.
 *
 * No dependencies, no framework, one listener per concern.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kc-faq]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('.kc-faq__item'));
  var expandBtn = root.querySelector('[data-kc-expand]');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- the slide ---------------------------------------------------------
   * A <details> shows and hides its panel instantly, and the CSS grid trick
   * only animates while the element is open. So on close we hold `open` until
   * the transition has run, then drop it.
   */
  items.forEach(function (item) {
    var summary = item.querySelector('summary');
    var panel = item.querySelector('.kc-faq__panel');
    if (!summary || !panel) return;

    summary.addEventListener('click', function (e) {
      if (reduceMotion.matches) return; // let the browser do it instantly
      if (!item.open) return; // opening needs no help — CSS animates from 0fr

      e.preventDefault();
      item.classList.add('is-closing');

      var done = function () {
        panel.removeEventListener('transitionend', done);
        clearTimeout(fallback);
        item.classList.remove('is-closing');
        item.open = false;
      };
      panel.addEventListener('transitionend', done);
      // transitionend does not fire if the row height is already 0 or the tab
      // is backgrounded; without this the row would stay stuck open.
      var fallback = setTimeout(done, 400);

      // force the closed row height while `open` is still true
      panel.style.gridTemplateRows = '0fr';
      requestAnimationFrame(function () {
        panel.style.removeProperty('grid-template-rows');
        panel.style.gridTemplateRows = '0fr';
      });
    });

    item.addEventListener('toggle', function () {
      if (item.open) panel.style.removeProperty('grid-template-rows');
      syncExpandLabel();
    });
  });

  /* ---- expand all / collapse all -----------------------------------------
   * The label is derived from state, not toggled, so closing one item after
   * "Expand all" flips it straight back.
   */
  function allOpen() {
    return items.length > 0 && items.every(function (i) { return i.open; });
  }

  function syncExpandLabel() {
    if (!expandBtn) return;
    var open = allOpen();
    expandBtn.textContent = open ? 'Collapse all' : 'Expand all';
    expandBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (expandBtn) {
    expandBtn.addEventListener('click', function () {
      var opening = !allOpen();
      items.forEach(function (item) {
        var panel = item.querySelector('.kc-faq__panel');
        if (panel) panel.style.removeProperty('grid-template-rows');
        item.classList.remove('is-closing');
        item.open = opening;
      });
      syncExpandLabel();
    });
    syncExpandLabel();
  }

  /* ---- topic nav ---------------------------------------------------------
   * Desktop sidebar links and mobile chips both land here. The offset differs
   * by breakpoint because the mobile chip rail is itself sticky and would sit
   * on top of the heading otherwise.
   */
  function jumpTo(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var offset = window.matchMedia('(max-width: 749px)').matches ? 150 : 110;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: y,
      behavior: reduceMotion.matches ? 'auto' : 'smooth'
    });
  }

  root.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-kc-jump]');
    if (!jump) return;
    var id = jump.getAttribute('data-target') ||
             (jump.getAttribute('href') || '').replace(/^#/, '');
    if (!id) return;
    e.preventDefault();
    jumpTo(id);
    // Move focus to the heading so a keyboard user lands where the page just
    // scrolled, instead of continuing from the nav.
    var target = document.getElementById(id);
    if (target) {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  });
})();
